import type { ListOption } from '../GenericBloc/GenericShortListFilter/GenericShortListDropdown';
import { SmileyIcon } from './icons/SmileyIcon';

export enum NPS_TYPE {
  PROMOTERS = 'promoters',
  PASSIVES = 'passives',
  DETRACTORS = 'detractors',
}

export const NPS_FILTER_OPTIONS: ListOption<NPS_TYPE>[] = [
  {
    value: NPS_TYPE.PROMOTERS,
    label: 'Promoters (Score 9-10)',
    content: <SmileyIcon score={4} size="s" />,
  },
  {
    value: NPS_TYPE.PASSIVES,
    label: 'Passives (Score 7-8)',
    content: <SmileyIcon score={2} size="s" />,
  },
  {
    value: NPS_TYPE.DETRACTORS,
    label: 'Detractors (Score 0-6)',
    content: <SmileyIcon score={1} size="s" />,
  },
];
